module.exports = __webpack_public_path__ + "static/media/ic_graphic_top_up_option_1.dfaced65.png";